import { app } from '../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.directory-integration.list', {
        url: '/list',
        component: 'companyDirectoryIntegrationList',
    });
}



// WEBPACK FOOTER //
// ./src/portal/states/company/directory-integration/list/directory-list.state.js